var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import Styles from './header-styles.scss';
import Loading from '@/presentation/components/loading/loading';
import { Auth } from 'aws-amplify';
import { getUserRolesInfo } from '@/main/utils/role-utils';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { useRecoilValue } from 'recoil';
import { currentUserState } from '@/presentation/components/atoms/atoms';
import { makeRemoteLogin } from '@/main/factories/usecases';
const login = makeRemoteLogin();
const SwitchRoles = ({ test1 }) => {
    const [loading, setLoading] = useState(true);
    const [canSwitch, setCanSwitch] = useState(false);
    const { currentUserSession } = useUserSesssion();
    const [isClient, setIsClient] = useState((currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.roleName) === 'Client');
    const [isStudent, setIsStudent] = useState((currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.roleName) === 'Student');
    const { setCurrentUser } = useRecoilValue(currentUserState);
    const updateUserSession = (roleName) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            setLoading(true);
            const loginStatus = yield login.loginStatus(roleName);
            if ((_a = loginStatus.user) === null || _a === void 0 ? void 0 : _a.id) {
                setCurrentUser(loginStatus);
                if (roleName === 'Client')
                    window.location.href = '/school-dashboard';
                if (roleName === 'Student')
                    window.location.href = '/student-dashboard';
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    });
    const checkRoles = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        setLoading(true);
        const response = yield Auth.currentAuthenticatedUser();
        if (response) {
            const roles = ((_b = getUserRolesInfo(response)) === null || _b === void 0 ? void 0 : _b.roles) || [];
            if (roles.includes('Client') && roles.includes('Student')) {
                setCanSwitch(true);
            }
        }
        setLoading(false);
    });
    const handleOnClick = (e, newRole) => {
        e.stopPropagation();
        if (loading)
            return;
        setLoading(true);
        if (newRole === 'Client') {
            setIsClient(true);
            setIsStudent(false);
        }
        if (newRole === 'Student') {
            setIsClient(false);
            setIsStudent(true);
        }
        updateUserSession(newRole);
    };
    useEffect(() => {
        checkRoles();
    }, []);
    if (!canSwitch)
        return null;
    return (React.createElement("li", null,
        loading && React.createElement(Loading, { noText: true, size: 18 }),
        React.createElement("hr", null),
        React.createElement("div", { className: Styles.wrapSwitchRol },
            React.createElement("div", { className: isClient ? Styles.iiButtonActive : Styles.iiButton, onClick: e => handleOnClick(e, 'Client') },
                React.createElement("span", null, "Admin")),
            React.createElement("div", { className: isStudent ? Styles.iiButtonActive : Styles.iiButton, onClick: e => handleOnClick(e, 'Student') },
                React.createElement("span", null, "Student"))),
        React.createElement("hr", null)));
};
export default SwitchRoles;
